// extracted by mini-css-extract-plugin
export default {"uploader":"uploader_uploader__hbHmW","uploader__icon":"uploader_uploader__icon__oUlJG","uploader__img":"uploader_uploader__img__jLQK7"};